/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Join_DiscussionInputs */

const en_join_discussion = /** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join Discussion`)
};

const es_join_discussion = /** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unirse a la Discusión`)
};

const fr_join_discussion = /** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre la discussion`)
};

const de_join_discussion = /** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskussion beitreten`)
};

const id_join_discussion = /** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gabung Diskusi`)
};

/** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */
const ja_join_discussion = en_join_discussion;

/** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */
const zh_join_discussion = en_join_discussion;

/** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */
const ar_join_discussion = en_join_discussion;

/** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */
const it_join_discussion = en_join_discussion;

/** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */
const ru_join_discussion = en_join_discussion;

/** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */
const pt_join_discussion = en_join_discussion;

/** @type {(inputs: Join_DiscussionInputs) => LocalizedString} */
const ko_join_discussion = en_join_discussion;

/**
* | output |
* | --- |
* | "Join Discussion" |
*
* @param {Join_DiscussionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const join_discussion = /** @type {((inputs?: Join_DiscussionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Join_DiscussionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_join_discussion(inputs)
	if (locale === "es") return es_join_discussion(inputs)
	if (locale === "fr") return fr_join_discussion(inputs)
	if (locale === "de") return de_join_discussion(inputs)
	if (locale === "ja") return ja_join_discussion(inputs)
	if (locale === "zh") return zh_join_discussion(inputs)
	if (locale === "ar") return ar_join_discussion(inputs)
	if (locale === "id") return id_join_discussion(inputs)
	if (locale === "it") return it_join_discussion(inputs)
	if (locale === "ru") return ru_join_discussion(inputs)
	if (locale === "pt") return pt_join_discussion(inputs)
	return ko_join_discussion(inputs)
});